/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * document_storage_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Type of channel.
 */
export type ChannelType = (typeof ChannelType)[keyof typeof ChannelType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChannelType = {
  public: 'public',
  private: 'private',
  direct_message: 'direct_message',
  team: 'team',
} as const;
